import React from "react";
import cn from "classnames";
import styles from "./Tooltip.module.sass";
import Icon from "../Icon";
// Pas besoin d'importer ReactTooltip ici car il est déjà importé dans TooltipGlodal

const Tooltip = ({ className, title, icon, place }) => {
  return (
    <div className={cn(styles.tooltip, className)}>
      <span data-tooltip-id="react-tooltip" data-tooltip-content={title} data-tooltip-place={place || "top"}>
        <Icon name={icon} />
      </span>
    </div>
  );
};

export default Tooltip;
